import { FEATURE_TEST } from './../modules/featureToggle/index';
import { environments } from '../siteConfig';
import isFeatureEnabled from 'src/modules/featureToggle/isFeatureEnabled';
import { getAdvertiserIds } from './advertiserIds';

export const DEV_EXPERIENCE = 'DevExperience';
const features = [FEATURE_TEST, DEV_EXPERIENCE];

interface FeatureByAdvertiserIds {
  featureName: string;
  advertiserIds: string[];
  isEnabledForAdvertiserId?: (s: string) => boolean;
}

const featuresByAdvertiserIds: FeatureByAdvertiserIds[] = [
  {
    featureName: DEV_EXPERIENCE,
    advertiserIds: ['1', '2'],
  },
  // Example for adding a feature that = is conditional on advertiserId
  // {
  //   featureName: FEATURE_MULTIPLE_WORK_HISTORY,
  //   advertiserIds: ['1'],
  //   isEnabledForAdvertiserId: (advertiserId: string) => {
  //     const lastNumber = advertiserId.charAt(advertiserId.length - 1);
  //     return lastNumber === '7' || lastNumber === '9';
  //   },
  // },
];

const isFeatureEnabledForAdvertiser = (featureName: string): boolean => {
  const { advertiserId } = getAdvertiserIds();

  const selectedFeature = featuresByAdvertiserIds.find(
    (feature) => feature.featureName === featureName,
  );

  const isInAdvertiserIdList =
    selectedFeature?.advertiserIds.some(
      (id) => `${id}` === `${advertiserId}`,
    ) ?? false;

  const isInTest =
    selectedFeature?.isEnabledForAdvertiserId && advertiserId
      ? selectedFeature.isEnabledForAdvertiserId(advertiserId)
      : false;

  return isInAdvertiserIdList || isInTest;
};

const getEnabledFeatures = (environment: string) => {
  const isDev = environment === environments.development;

  if (isDev) {
    // Use this if you want to enable/disable features in dev
    return [DEV_EXPERIENCE];
  }

  const enabledFeatures: string[] = [];
  features.forEach((feature) => {
    if (isFeatureEnabled(feature) || isFeatureEnabledForAdvertiser(feature)) {
      enabledFeatures.push(feature);
    }
  });

  return enabledFeatures;
};

export default getEnabledFeatures;
